import Link from 'next/link';

import { useMediaQuery, Grid, Button } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';

import PropTypes from 'prop-types';

import { Image } from '@/src/components/atoms';
import { SectionHeader } from '@/src/components/molecules';

const useStyles = makeStyles(theme => ({
  pagePaddingTop: {
    paddingTop: theme.spacing(3),
    [theme.breakpoints.up('md')]: {
      paddingTop: theme.spacing(5),
    },
  },
  image: {
    width: 500,
    [theme.breakpoints.down('sm')]: {
      width: 300,
    },
  },
}));

export default function Hero(props) {
  const { className, onLearnMore, ...rest } = props;

  const classes = useStyles();
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), { defaultMatches: true });

  return (
    <div className={className} {...rest}>
      <Grid container justifyContent="space-between" spacing={isMd ? 4 : 2}>
        <Grid item xs={12} md={6} data-aos="fade-up">
          <SectionHeader
            title="Venda online produtos ou serviços educacionais"
            subtitle="Baixo investimento, rápida implantação e flexível para venda 
          tanto de produtos quanto serviços de educação."
            ctaGroup={[
              <Button
                color="primary"
                variant="outlined"
                size="large"
                onClick={onLearnMore}
                aria-label="Saiba mais"
                key="learnMoreCta">
                Saiba mais
              </Button>,
              <Link
                href="/schedule?utm_campaign=solutions&utm_content=hero"
                key="scheduleCta"
                passHref>
                <Button
                  component="a"
                  color="primary"
                  variant="contained"
                  size="large"
                  aria-label="Agendar demonstração">
                  Agendar demonstração
                </Button>
              </Link>,
            ]}
            align={isMd ? 'left' : 'center'}
            disableGutter
            titleVariant="h3"
          />
        </Grid>
        <Grid
          item
          container
          justifyContent="center"
          alignItems="center"
          xs={12}
          md={6}
          data-aos="fade-up">
          <Image src="/images/illustrations/solutions/hero.svg" className={classes.image} />
        </Grid>
      </Grid>
    </div>
  );
}

Hero.propTypes = {
  className: PropTypes.string,
  onLearnMore: PropTypes.func,
};
